var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{attrs:{"color":"yellow lighten-1 text-center","elevation":"0"}},[_c('v-img',{staticClass:"pa-0",attrs:{"src":require("@/assets/images/img-general/logo.png"),"width":"90","height":"40","max-height":"100%","align-center":"","contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }